<template>
  <div
    :class="['to-top', {visible: isVisible}]"
    @click="scrollToTop"
  >
    <f-sprite-icon :icon-link="$options.icons.IconArrow.id" />
  </div>
</template>

<script>
import IconArrow from '../../assets/icons/arrow.svg';

export default {
  name: 'ToTop',

  icons: {
    IconArrow
  },

  data() {
    return {
      observer: null,
      target: null,
      isVisible: false
    };
  },

  mounted() {
    this.startObserver();
  },

  beforeDestroy() {
    this.stopObserver();
  },

  methods: {
    startObserver() {
      this.target = document.getElementById('header');
      if (!this.target) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          entry.isIntersecting ? this.isVisible = false : this.isVisible = true;
        })
      });

      this.observer.observe(this.target);

    },

    stopObserver() {
      if (this.observer && this.target) {
        this.observer.unobserve(this.target);
        this.observer = null;
      }
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
};
</script>

<style lang="scss">
.to-top {
  z-index: 2;
  position: sticky;
  bottom: 26px;
  left: 100%;
  width: 40px;
  height: 40px;
  padding: 10px;
  margin-right: 8px;
  margin-bottom: 26px;
  border: 1px solid $gray_lu;
  background-color: #fff;
  border-radius: 50%;
  color: $gray;
  cursor: pointer;
  opacity: 0;
  transition: background-color .2s ease, color .2s ease, opacity .2s ease;

  &.visible {
    opacity: 1;
  }
}

@include breakpoint("desktop") {
  .to-top {
    bottom: 59px;
    margin-right: 24px;
    margin-bottom: 59px;
    width: 48px;
    height: 48px;
    padding: 12px;

    &:hover {
      color: $black;
      background-color: $gray_bgr;
    }
  }
}
</style>